import React from 'react';

import HeroIMG from './heroBig.jpg';
import HeroMediumIMG from './heroMedium.jpg';
import HeroSmallIMG from './heroSmall.jpg';

export const HeroBackground = (props) => {
  if (props === 'small') return HeroSmallIMG;
  else if (props === 'medium') return HeroMediumIMG;
  return HeroIMG;
};

export default HeroBackground;



// WEBPACK FOOTER //
// ./src/components/UI/Img/Hero/index.jsx